import shiColors from "shared-ui/src/theme/shiColors";

export const CACHE_KEY_DETAILED_RETAINER_EXPENSE_BY_CONTRACT_ID =
  "detailed-retainer-expense-by-contract-id";

export const retainerBurndownStyles = {
  position: "relative",
  height: "450px",
  width: "100%",
};

export const retainerTypeMapping = {
  RetainerSigning: {
    color: shiColors.blue.DEFAULT,
    label: "RetainerSigning",
    legendLabel: "Retainer Purchase",
    type: "Retainer Purchase",
    operationType: "add",
  },
  Other: {
    color: shiColors.pink.DEFAULT,
    label: "Other",
    legendLabel: "Pending Usage",
    type: "Pending",
    operationType: "subtract",
  },
  Remaining: {
    color: shiColors.green.DEFAULT,
    label: "Remaining",
    legendLabel: "Remaining",
    type: "Remaining",
    operationType: null,
  },
  TicketExpense: {
    color: shiColors.orange.light,
    label: "TicketExpense",
    legendLabel: "Hours (Usage)",
    type: "Hours",
    operationType: "subtract",
  },
  ProjectTaskExpense: {
    color: shiColors.pink.dark,
    label: "ProjectTaskExpense",
    legendLabel: "Project Hours (Usage)",
    type: "Project Hours",
    operationType: "subtract",
  },
};

export const BillingTypes = {
  retainer: "Retainer",
  fixedPrice: "Fixed Price",
  recurringService: "Recurring Service",
  timeAndMaterials: "Time & Materials",
};
